import { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../../redux/actions';
import { confirmAsync } from '../../../utils/functions/globalDialog';

export function useTenderDocuments({ opportunity, onChanged, showSnack }) {
  const dispatch = useDispatch();
  const [docType, setDocType] = useState('');
  const [docFiles, setDocFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  const upload = async () => {
    if (docFiles.length === 0 || !docType.trim()) return;
    setUploading(true);
    try {
      const result = await dispatch(actions.uploadTenderDocuments({
        opportunityId: opportunity.id, docType: docType.trim(), files: docFiles,
      }));
      if (result.failed?.length) {
        showSnack(`อัปโหลดไม่สำเร็จ ${result.failed.length} ไฟล์`, 'error');
      } else {
        showSnack('อัปโหลดเอกสารสำเร็จ');
      }
      setDocType('');
      setDocFiles([]);
      onChanged();
    } catch (err) {
      showSnack(err.message || 'อัปโหลดไม่สำเร็จ', 'error');
    } finally {
      setUploading(false);
    }
  };

  const remove = async (docId) => {
    if (!(await confirmAsync('ต้องการลบเอกสารนี้ใช่หรือไม่?'))) return;
    try {
      await dispatch(actions.deleteTenderDocument({ id: docId }));
      onChanged();
    } catch (err) {
      showSnack(err.message || 'ลบไม่สำเร็จ', 'error');
    }
  };

  return {
    docType, setDocType, docFiles, setDocFiles, uploading, upload, remove,
  };
}

export default useTenderDocuments;
